export default {
  namespaced: true,
  storage_provider: {
    id: 'Id',
    title: "Proveedor de Almacenamiento",
    name: "Nombre",
    description: "Descripción",
    type: "Tipo",
    config: "Configuración",
    folder: "Carpeta",
    bucket_name: "Nombre del bucket",
    region: "Región",
    access_key_id: "ID de clave de acceso",
    secret_access_key: "Clave de acceso secreta",
    endpoint: "Punto de enlace",
    account_name: "Nombre de cuenta",
    account_key: "Clave de cuenta",
    container_name: "Nombre del contenedor",
    sas_token: "Token SAS",
    message: {
      add: "Proveedor de Almacenamiento Agregado Correctamente",
      edit: "Proveedor de Almacenamiento Editado Correctamente",
      delete: "Proveedor de Almacenamiento Eliminado Correctante",
      error: "Ocurrio un error",
    }
  },
};